module.exports = __webpack_public_path__ + "img/horse-icon.1e9bac56.svg";